/**
 * Normalização do payload de /medical-records/my-doctors|my-patients.
 */

export function normalizeConnectionsPayload<T>(raw: unknown): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (raw && typeof raw === 'object' && Array.isArray((raw as { data?: unknown }).data)) {
    return (raw as { data: T[] }).data;
  }
  return [];
}
